// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"Rp-z","imageAndVideoCount":"Sp-z","imageAndVideoContainer":"Tp-z","viewAllReviews":"Up-z"};